import React, { useEffect, useState } from "react";
import GeneralSettingsService from '../services/GeneralSettingsService';

const RatesSection = () => {
    const [rates, setRates] = useState([]);
    const [loading, setLoading] = useState(true);

    const currentDate = new Date().toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });

    useEffect(() => {
        const fetchRates = async () => {
            try {
                const data = await GeneralSettingsService.getAllParameters();
                if (data.length > 0 && data[0].paramRates) {
                    setRates(data[0].paramRates);
                }
            } catch (error) {
                console.error('Error fetching rates:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRates();
    }, []);

    const countryFlags = {
        'Cameroun': 'assets/flags/cameroon.png',
        'Bénin': 'assets/flags/benin.png',
        'Burkina Faso': 'assets/flags/burkina-faso.png',
        'Côte d\'Ivoire': 'assets/flags/ivory-coast.png',
        'Sénégal': 'assets/flags/senegal.png',
    };

    const styles = {
        loadingContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
        },
        spinner: {
            border: '4px solid rgba(0, 0, 0, 0.1)',
            borderLeftColor: '#09f',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite',
        },
        ratesContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '20px',
            padding: '20px',
            borderRadius: '8px',
        },
        sectionTitle: {
            fontSize: '1.8em',
            marginBottom: '20px',
            textAlign: 'center',
            fontWeight: 'bold',
            width: '100%',
        },
        rateItem: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '20px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            minWidth: '280px',
            transition: 'transform 0.3s',
        },
        rateItemHover: {
            transform: 'scale(1.05)',
        },
        flag: {
            width: '40px',
            height: '30px',
            marginBottom: '10px',
            borderRadius: '5px',
        },
        countryName: {
            fontSize: '1.3em',
            marginBottom: '5px',
            color: 'rgb(26 123 255)',
        },
        rateValue: {
            fontSize: '1.4em',
            color: '#007BFF',
            fontWeight: 'bold',
        },
    };

    if (loading) {
        return (
            <div style={styles.loadingContainer}>
                <div style={styles.spinner}></div>
            </div>
        );
    }

    return (
        <div style={styles.ratesContainer}>
            <p style={styles.sectionTitle}>Taux de Change du {currentDate}</p>
            {rates.map((rate, index) => (
                <div
                    key={index}
                    style={Object.assign({}, styles.rateItem, {
                        ':hover': styles.rateItemHover,
                    })}
                >
                    <img src={countryFlags[rate.country]} alt={rate.country} style={styles.flag}/>
                    <p style={styles.countryName}>{rate.country}</p>
                    <p style={styles.rateValue}>
                        1 CAD => {rate.rate} {rate.country === 'Cameroun' ? 'XAF' : 'XOF'}
                    </p>
                </div>
            ))}
        </div>
    );
};

export default RatesSection;
